/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpBigQueryResourceMaterializedViewsInner } from '../models/GcpBigQueryResourceMaterializedViewsInner';
import { GcpBigQueryResourceRoutinesInner } from '../models/GcpBigQueryResourceRoutinesInner';
import { GcpBigQueryResourceTablesInner } from '../models/GcpBigQueryResourceTablesInner';
import { GcpBigQueryResourceViewsInner } from '../models/GcpBigQueryResourceViewsInner';

/**
* Properties of the original GCP BigQuery dataset. Present only when `resourceType` is set to `GCP_BIG_QUERY`. 
*/
export class GcpBigQueryResource {
  /**
  * BigQuery dataset ID.
  */
  'datasetId': string;
  /**
  * Geographic location of the dataset.
  */
  'location': string;
  /**
  * Description of the dataset.
  */
  'description'?: string;
  /**
  * Labels attached to the dataset.
  */
  'labels'?: { [key: string]: string; };
  /**
  * Default expiration time for tables in the dataset, in milliseconds.
  */
  'defaultTableExpirationMs'?: number;
  /**
  * Default expiration time for partitions in the dataset, in milliseconds.
  */
  'defaultPartitionExpirationMs'?: number;
  /**
  * Dataset creation time.
  */
  'creationTime'?: Date;
  /**
  * Last modification time of the dataset.
  */
  'lastModifiedTime'?: Date;
  /**
  * Storage billing model (LOGICAL or PHYSICAL).
  */
  'storageBillingModel': string;
  /**
  * Total logical storage size in bytes.
  */
  'totalLogicalBytes': number;
  /**
  * Total physical storage size in bytes.
  */
  'totalPhysicalBytes': number;
  /**
  * Dataset active logical storage size in bytes.
  */
  'activeLogicalBytes'?: number;
  /**
  * Dataset long-term logical storage size in bytes.
  */
  'longTermLogicalBytes'?: number;
  /**
  * Dataset active physical storage size in bytes.
  */
  'activePhysicalBytes'?: number;
  /**
  * Dataset long-term physical storage size in bytes.
  */
  'longTermPhysicalBytes'?: number;
  /**
  * Time travel physical storage size in bytes.
  */
  'timeTravelPhysicalBytes': number;
  /**
  * Time travel window in days (default 7 days).
  */
  'timeTravelWindowDays': number;
  /**
  * Customer-Managed Encryption Key (CMEK) name used for dataset encryption.
  */
  'cmekKeyName'?: string;
  /**
  * Number of tables in the dataset.
  */
  'tableCount': number;
  /**
  * Number of views in the dataset.
  */
  'viewCount': number;
  /**
  * Number of materialized views in the dataset.
  */
  'materializedViewCount': number;
  /**
  * Number of routines (functions/procedures) in the dataset.
  */
  'routineCount': number;
  /**
  * List of all components (tables, views, materialized views) in the dataset.
  */
  'tables'?: Array<GcpBigQueryResourceTablesInner>;
  /**
  * List of views in the dataset.
  */
  'views'?: Array<GcpBigQueryResourceViewsInner>;
  /**
  * List of materialized views in the dataset.
  */
  'materializedViews'?: Array<GcpBigQueryResourceMaterializedViewsInner>;
  /**
  * List of routines (functions/procedures) in the dataset.
  */
  'routines'?: Array<GcpBigQueryResourceRoutinesInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "datasetId",
      "baseName": "datasetId",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    },
    {
      "name": "labels",
      "baseName": "labels",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "defaultTableExpirationMs",
      "baseName": "defaultTableExpirationMs",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "defaultPartitionExpirationMs",
      "baseName": "defaultPartitionExpirationMs",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "creationTime",
      "baseName": "creationTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "lastModifiedTime",
      "baseName": "lastModifiedTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "storageBillingModel",
      "baseName": "storageBillingModel",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalLogicalBytes",
      "baseName": "totalLogicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "totalPhysicalBytes",
      "baseName": "totalPhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "activeLogicalBytes",
      "baseName": "activeLogicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "longTermLogicalBytes",
      "baseName": "longTermLogicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "activePhysicalBytes",
      "baseName": "activePhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "longTermPhysicalBytes",
      "baseName": "longTermPhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "timeTravelPhysicalBytes",
      "baseName": "timeTravelPhysicalBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "timeTravelWindowDays",
      "baseName": "timeTravelWindowDays",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "cmekKeyName",
      "baseName": "cmekKeyName",
      "type": "string",
      "format": ""
    },
    {
      "name": "tableCount",
      "baseName": "tableCount",
      "type": "number",
      "format": "int32"
    },
    {
      "name": "viewCount",
      "baseName": "viewCount",
      "type": "number",
      "format": "int32"
    },
    {
      "name": "materializedViewCount",
      "baseName": "materializedViewCount",
      "type": "number",
      "format": "int32"
    },
    {
      "name": "routineCount",
      "baseName": "routineCount",
      "type": "number",
      "format": "int32"
    },
    {
      "name": "tables",
      "baseName": "tables",
      "type": "Array<GcpBigQueryResourceTablesInner>",
      "format": ""
    },
    {
      "name": "views",
      "baseName": "views",
      "type": "Array<GcpBigQueryResourceViewsInner>",
      "format": ""
    },
    {
      "name": "materializedViews",
      "baseName": "materializedViews",
      "type": "Array<GcpBigQueryResourceMaterializedViewsInner>",
      "format": ""
    },
    {
      "name": "routines",
      "baseName": "routines",
      "type": "Array<GcpBigQueryResourceRoutinesInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpBigQueryResource.attributeTypeMap;
  }

  public constructor() {
  }
}

